import { Link, Text, View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';
import type { StateTermItem } from '@/utils/stateTerms';

/** PDF version of a data-driven state section (utils/stateTerms). */
const StateTermsListPdf = ({
  state,
  items,
}: {
  state: string;
  items: StateTermItem[];
}) => (
  <View style={styles.section}>
    <Text style={styles.title}>{state} Specific Terms</Text>
    <View style={styles.list}>
      {items.map((item, i) => (
        <Text key={i} style={styles.listItem}>
          {i + 1}.{' '}
          {item.link && (
            <>
              <Link src={item.link.url} style={styles.underline}>
                {item.link.label}
              </Link>{' '}
            </>
          )}
          {item.text}
        </Text>
      ))}
    </View>
  </View>
);

export default StateTermsListPdf;
